import React from "react";

import { PrimaryButton, SecondaryButton } from "@components/v2/buttons";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { type TileDescriptor } from "@features/overview-v2/types";

export interface DeleteCardProps {
  onCancel(): void;
  readonly tile: TileDescriptor;
}

export const DeleteCard = ({ onCancel, tile }: DeleteCardProps) => {
  const { deleteTile } = useOverviewContext();

  return (
    <div>
      <h3 className="text-lg font-bold mb-1 relative">Delete card?</h3>
      <div className="mt-4">
        <PrimaryButton
          className="font-bold text-sm bg-mars px-5 mr-3 mb-3"
          size="md"
          onClick={() => {
            deleteTile(tile);
          }}
        >
          YES, DELETE
        </PrimaryButton>
        <SecondaryButton
          className="font-bold text-sm px-5"
          size="md"
          onClick={onCancel}
        >
          NO, CANCEL
        </SecondaryButton>
      </div>
    </div>
  );
};
